import { useEffect, useState } from "react";
import makeAnimated from "react-select/animated";
import AsyncSelect from "react-select/async";
import useGetHook from "../../../customHooks/useGetHook";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { json } from "react-router-dom";
const animatedComponents = makeAnimated();

const MultipleSelectField = (props: any) => {
  const {
    register,
    setValue,
    label,
    queryKey,
    url,
    value,
    clearErrors,
    errors,
    props: otherProps,
  } = props;
  const limit = 10;
  const [query, setQuery] = useState("");
  const { data: serverData } = useGetHook({
    queryKey: [
      queryKey,
      `${queryKey}-${limit}-${query}-${JSON.stringify(otherProps)}`,
    ],
    url: url,
    params: {
      limit: limit,
      offset: 0,
      search: query,
      ...otherProps,
    },
  });
  const [defaultValue, setDefaultValue] = useState([...value]);
  const onChange = (value: any) => {
    setValue(register?.name, value);
    setDefaultValue(value);
    clearErrors(register?.name);
  };

  const loadOptions = (
    inputValue: string,
    callback: (options: any) => void
  ) => {
    setQuery(inputValue?.length == 1 ? "" : inputValue);
    setTimeout(() => {
      callback(
        serverData?.results?.map((item: any, index: number) => ({
          label: item?.name,
          value: item?.id,
        }))
      );
    }, 1000);
  };

  return (
    <div className={tw`mt-4`}>
      <label htmlFor="">{label}</label>
      <AsyncSelect
        value={defaultValue}
        loadOptions={loadOptions}
        components={animatedComponents}
        closeMenuOnSelect={false}
        onChange={onChange}
        isMulti
        styles={{
          control(base, props) {
            return {
              ...base,
              backgroundColor: "#EEF5F4",
              border: props.menuIsOpen || props.isFocused ? "none" : "none",
              outline:
                props.menuIsOpen || props.isFocused
                  ? "none !important"
                  : "none  !important",
              cursor: "text",
            };
          },
        }}
        defaultOptions={
          serverData?.results?.map((item: any, index: number) => ({
            label: item?.name,
            value: item?.id,
          })) ?? []
        }
      />
      {errors && (
        <p className={tw`text-red-500 text-xs my-1`}>{errors.message}</p>
      )}
    </div>
  );
};

export default MultipleSelectField;
